import { DateHelper } from "@swivl-mono/helpers";

import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { UnitInterface } from "../Unit/Unit.Interface";
import { UserInterface } from "../User/User.Interface";
import { LeasePropKey } from "../Variables/Generated/LeasePropKey.Data";

export interface LeaseInterface extends OrgBaseInterface {
  locationId: number;
  unitId?: number;
  userId?: number;
  user?: UserInterface;
  tenantId?: number;
  active: boolean;
  externalUnitId?: string;
  externalLeaseId?: string;
  externalTenantId?: string;
  fmsType: string;
  moveInDate?: Date;
  moveOutDate?: Date;
  startDate?: Date;
  endDate?: Date;
  rent?: number;
  paidThroughDate?: Date;
  balance?: number;
  autopay?: boolean;
  daysPastDue?: number;
  accountStatus?: LeaseAccountStatus;
  paymentStatus?: LeaseAccountPaymentStatus;
  dueDate?: Date;
  accessCode?: string;
  accessCodeQueryId?: string;
  raw?: any;

  unit?: UnitInterface;
  deletedDate?: Date;
}

export const LeaseSyncOnFields = new Set<keyof LeaseInterface>([
  "active",
  "externalUnitId",
  "externalLeaseId",
  "externalTenantId",
  "moveInDate",
  "moveOutDate",
  "startDate",
  "endDate",
  "rent",
  "paidThroughDate",
  "balance",
  "autopay",
  "daysPastDue",
  "accountStatus",
  "paymentStatus",
  "dueDate",
  "accessCode",
  "accessCodeQueryId",
  "userId",
  "tenantId",
  "unitId"
]);

// This data type is used to normalize the lease data for FMS integration before it is saved or synced.
export type NormalizedFMSLeaseInterface = Omit<
  LeaseInterface,
  "id" | "createdAt" | "updatedAt" | "deletedDate" | "userId" | "user" | "orgId" | "org" | "locationId" | "unit"
>;
export type SaveLeaseInterface = Omit<LeaseInterface, "id" | "createdAt" | "updatedAt" | "deletedDate">;

export function LeaseVarsForLease(lease: LeaseInterface): { [key in LeasePropKey]: string } {
  // Psuedos Days past due
  // Status
  return {
    [LeasePropKey.Active]: lease.active ? "1" : "0",

    [LeasePropKey.UnitId]: lease.unitId ? lease.unitId.toString() : "",
    [LeasePropKey.UserId]: lease.userId ? lease.userId.toString() : "",
    // [LeasePropKey.AccessCode]: lease.accessCode ? lease.accessCode : '',
    // [LeasePropKey.DivinciCode]: lease.divinciCode ? lease.divinciCode : '',

    [LeasePropKey.TenantId]: lease.tenantId ? lease.tenantId.toString() : "",
    [LeasePropKey.ExternalUnitId]: lease.externalUnitId ? lease.externalUnitId : "",
    [LeasePropKey.ExternalLeaseId]: lease.externalLeaseId ? lease.externalLeaseId : "",
    [LeasePropKey.FMSType]: lease.fmsType,
    [LeasePropKey.MoveInDate]: lease.moveInDate ? DateHelper.normalize(lease.moveInDate).toISOString() : "",
    [LeasePropKey.MoveOutDate]: lease.moveOutDate ? DateHelper.normalize(lease.moveOutDate).toISOString() : "",
    [LeasePropKey.StartDate]: lease.startDate ? DateHelper.normalize(lease.startDate).toISOString() : "",
    [LeasePropKey.EndDate]: lease.endDate ? DateHelper.normalize(lease.endDate).toISOString() : "",
    [LeasePropKey.Rent]: lease.rent != null ? lease.rent.toString() : "",
    [LeasePropKey.PaidThroughDate]: lease.paidThroughDate ? DateHelper.normalize(lease.paidThroughDate).toISOString() : "",
    [LeasePropKey.Balance]: lease.balance != null ? lease.balance.toString() : "",
    [LeasePropKey.AccountStatus]: lease.accountStatus ? lease.accountStatus : "",
    [LeasePropKey.PaymentStatus]: lease.paymentStatus ? lease.paymentStatus : "",
    [LeasePropKey.AutoPayEnabled]: lease.autopay ? "1" : "0",
    [LeasePropKey.DaysPastDue]: lease.daysPastDue != null ? lease.daysPastDue.toString() : "",
    [LeasePropKey.DueDate]: lease.dueDate ? DateHelper.normalize(lease.dueDate).toISOString() : "",
  };
}

export enum LeaseAccountStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

//NOTE: We may want to add a status for "paid".
export enum LeaseAccountPaymentStatus {
  PAST_DUE = "past due",
  DUE = "due",
  UNKNOWN = "unknown",
}
